export const reportConstants = {
  LOAD_LOCAL: "LOAD_LOCAL",
  CHANGE_AREA: "CHANGE_AREA",
  CHANGE_STATUS: "CHANGE_STATUS",
  CHANGE_LOCAL: "CHANGE_LOCAL",
  LOAD_STATUS: "LOAD_STATUS",
  CHANGE_START_DATE: "CHANGE_START_DATE",
  CHANGE_END_DATE: "CHANGE_END_DATE",
  REPORT_DATA_REQUEST: "REPORT_DATA_REQUEST",
  REPORT_DATA_SUCCESS: "REPORT_DATA_SUCCESS",
  REPORT_DATA_CHART_SUCCESS: 'REPORT_DATA_CHART_SUCCESS',
  REPORT_DATA_FAILURE: "REPORT_DATA_FAILURE",
  CLEAR_FILTERS: "CLEAR_FILTERS",
  CLEAR_LOCAL: "CLEAR_LOCAL",
  CLEAR_AREA: "CLEAR_AREA",
  CLEAR_STATUS: "CLEAR_STATUS",
  CLEAR_ALL_REPORT: "CLEAR_ALL_REPORT",
  GET_REPORT_CSV_REQUEST: "GET_REPORT_CSV_REQUEST",
  GET_REPORT_CSV_SUCCESS: "GET_REPORT_CSV_SUCCESS",
  GET_REPORT_CSV_FAILURE: "GET_REPORT_CSV_FAILURE",
  SER_REPORT_TAB: "SER_REPORT_TAB",
  PRE_REPORT_DATA_REQUEST: "PRE_REPORT_DATA_REQUEST"
}